module.exports = "<nav class=\"navbar navbar-inverse\">\r\n  <div class=\"container-fluid\">\r\n    <ul class=\"nav navbar-nav\">\r\n      <li><a routerLink=\"/home\" routerLinkActive=\"active\">01</a></li>\r\n      <li><a routerLink=\"/facestarpage\" routerLinkActive=\"active\">02</a></li>\r\n      <li><a routerLink=\"/sticky\" routerLinkActive=\"active\">03</a></li>\r\n      <li><a routerLink=\"/ar\" routerLinkActive=\"active\">04</a></li>\r\n    </ul>\r\n  </div>\r\n</nav> "


//////////////////
// WEBPACK FOOTER
// ./src/app/lateralbar/lateralbar.component.html
// module id = ./src/app/lateralbar/lateralbar.component.html
// module chunks = main